
import { Steps } from 'antd';
import { useSelector } from 'react-redux';
import UploadVipUsersSheet from "./uploadVipUsersSheet"
import ViewUploadedSheet from './viewUploadedSheet';
import CheckUploadedData from './checkUploadedData';
const { Step } = Steps;

interface IRootState {
    [key: string]: any;
    step: number,
}

export default function ViewVipUsers() {
    const step: any = useSelector<IRootState>(state => state.truckingReducer.step);
    const steps = [
        {
            title: 'Choose and upload the file',
            content: <UploadVipUsersSheet />,
        },
        {
            title: 'Data confirmation',
            content: <ViewUploadedSheet/>,
        },
        {
            title: 'Check and upload data',
            content: <CheckUploadedData/>,
        },
    ];
    return (
        <div className='bulkCreateTruckingUsers p-1'>
            <Steps type='navigation' current={step} className='uploadVipUsers'>
                {steps.map(item => (
                    <Step key={item.title} title={item.title} />
                ))}
            </Steps>
            <div className="steps-content">{steps[step].content}</div>
        </div>
    )
}